import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";

import { useNavigate } from "react-router";

import Loading from "../components/Loading";
import Menu from "../components/Menu";

import api from "../services/api";

export default function Importacoes() {
    const [date, setDate] = useState(new Date());
    const [data, setData] = useState([]);
    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState(null);
    const [turma1, setTurma1] = useState('');
    const [turma2, setTurma2] = useState('');
    const [type, setType] = useState('.csv');

    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [visibleUpload, setVisibleUpload] = useState(false);

    const toast = useRef(null);
    const navigate = useNavigate();

    const handleUploadFile = (event) => {
        let file = event.files[0];
        var formData = new FormData();
        formData.append("file", file);
        if(type === '.csv') {
            if((turma1 === turma2)||(turma1 === '')||(turma2 === '')) {
                toast.current.show({
                    summary: 'Aviso',
                    severity: 'warn',
                    detail: 'Selecione as turmas corretamente, sem que haja duplicidade.'
                });
                return;
            }

            api.post(`dados/upload-csv/${turma1}/${turma2}/${selected}`, formData, {
                headers: {
                    'Content-Type': `multipart/form-data; boundary=${formData._boundary}`
                }
            }).then((response) => {
                hideDialogUpload();
                setTurma1('');
                setTurma2('');
                toast.current.show({
                    summary: 'Concluído',
                    severity: 'success',
                    detail: response.data.message
                });
            }).catch((error) => {
                toast.current.show({
                    summary: 'Ocorreu um Erro',
                    severity: 'error',
                    detail: error.response.data.message
                });
            });
        } else if(type === '.xml') {
            setLoading(true);
            let obj = {
                "importacao_id" : selected
            };
            const json = JSON.stringify(obj);
            const blob = new Blob([json], {
                type: "application/json"
            });
            formData.append("json", blob);
            
            api.post(`dados/upload-xml/${selected}`, formData, {
                headers: {
                    'Content-Type': `multipart/form-data; boundary=${formData._boundary}`
                }
            }).then((response) => {
                setLoading(false);
                hideDialogUpload();
                toast.current.show({
                    summary: 'Concluído',
                    severity: 'success',
                    detail: response.data.message
                });
            }).catch((error) => {
                setLoading(false);
                toast.current.show({
                    summary: 'Ocorreu um Erro',
                    severity: 'error',
                    detail: error.response.data.message
                });
            });
        }
    }

    const handleSubmit = () => {
        if (date === null || date === '') {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Por favor, preencha todos os campos antes de prosseguir.'
            });
            return;
        }
        let formated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        setLoading(true);
        api.post('dados/importacao/store', {
            "data": formated
        }).then((response) => {
            getData();
            hideDialog();
            setLoading(false);

            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleDelete = (rowData, rowIndex) => {
        confirmDialog({
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: 'Cancelar',
            rejectClassName: 'p-button-secondary',
            header: 'Confirmação',
            message: 'Você tem certeza que deseja excluir a Importação Nº ' + rowData.id + '? Os dados não podem ser recuperados...',
            accept: () => {
                api.post('dados/importacao/delete', {
                    "importacao_id": rowData.id
                }).then((response) => {
                    if (response.status === 200) {
                        let copy = [...data];
                        copy.splice(rowIndex, 1);
                        setData(copy);

                        toast.current.show({
                            summary: 'Concluído',
                            severity: 'success',
                            detail: response.data.message
                        });
                    }
                }).catch((error) => {
                    toast.current.show({
                        summary: 'Ocorreu um Erro',
                        severity: 'error',
                        detail: error.response.data.message
                    });
                });
            }
        });
    }

    const showDialog = () => {
        setVisible(true);
    }

    const hideDialog = () => {
        setVisible(false);
        setDate(new Date());
    }

    const showDialogUpload = (type) => {
        setVisibleUpload(true);
    }

    const hideDialogUpload = () => {
        setVisibleUpload(false);
    }

    const getData = () => {
        setLoading(true);
        api.get('dados/importacao/index').then((response) => {
            setData(response.data);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: 'Não foi possível conectar ao Servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });

        api.get('cadastros/turmas').then((response) => {
            setOptions(response.data);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: 'Não foi possível conectar ao Servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }

    useEffect(() => {
        getData();
    }, []);

    if(loading) {
        return (
            <Loading />
        )
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Dialog
                footer={() => (
                    <div>
                        <Button className="p-button-secondary" onClick={hideDialog}>Cancelar</Button>
                        <Button className="p-button-success" onClick={handleSubmit}>Salvar</Button>
                    </div>
                )}
                header="Cadastrar"
                onHide={hideDialog}
                style={{ minWidth: '30vw' }}
                visible={visible}
            >
                <div className="p-fluid">
                    <div className="p-field">
                        <Calendar
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            placeholder="Importação do dia..."
                            onChange={e => setDate(e.value)}
                            value={date}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Importar Arquivo"
                onHide={hideDialogUpload}
                style={{ minWidth: '50vw' }}
                visible={visibleUpload}
            >
                <h2>Importação Nº {selected}</h2>
                <div className="p-fluid">
                    {type === '.csv' ? (
                        <>
                            <div className="p-field">
                                <label htmlFor="turma_1">Turma 1</label>
                                <Dropdown
                                    onChange={e => setTurma1(e.value)}
                                    optionLabel="nome"
                                    optionValue="id"
                                    options={options}
                                    value={turma1}
                                />
                            </div>
                            <div className="p-field">
                                <label htmlFor="turma_2">Turma 2</label>
                                <Dropdown
                                    onChange={e => setTurma2(e.value)}
                                    optionLabel="nome"
                                    optionValue="id"
                                    options={options}
                                    value={turma2}
                                />
                            </div>
                        </>
                    ) : null}
                    <FileUpload
                        cancelLabel="Cancelar"
                        chooseLabel="Escolher arquivo"
                        uploadLabel="Enviar"
                        customUpload
                        uploadHandler={handleUploadFile}
                        accept={type}
                        url=""
                    />
                </div>
            </Dialog>

            <Card header={() => (
                <div className="p-d-flex p-flex-row p-jc-between p-ai-start">
                    <h1 className="p-m-2">Importações</h1>
                    <Button className="p-button-primary p-m-2" label="Nova importação" onClick={showDialog} />
                </div>
            )} className="p-m-3">
                <DataTable
                    filterDisplay="row"
                    paginator
                    rows={8} 
                    responsiveLayout="scroll"
                    value={data}
                >
                    <Column showFilterMatchModes={false} filter sortable header="ID" field="id" style={{ width: '33%'}} />
                    <Column showFilterMatchModes={false} sortField="data" filterField="formated" filter sortable header="Data" field="data" style={{ width: '33%' }} body={(rowData) => {
                        return rowData.formated;
                    }}/>
                    <Column header="Ações" style={{ width: '33%' }} body={(rowData, index) => (
                        <div>
                            <Button
                                className="p-button-warning p-mr-1"
                                onClick={() => {
                                    navigate(`/importacoes/dados/${rowData.id}`)
                                }}
                                icon="pi pi-list"
                                title="Clique para listar as importações"
                            />
                            <Button 
                                className="p-button-secondary p-mr-1"
                                icon="pi pi-percentage"
                                onClick={() => {
                                    navigate(`/eficiencia/${rowData.id}`)
                                }}
                                title="Clique para visualizar a eficiência"
                            />
                            <Button
                                className="p-button-success p-mr-1"
                                icon="pi pi-file-excel"
                                onClick={() => {
                                    setSelected(rowData.id);
                                    setType('.csv');
                                    showDialogUpload('.csv');
                                }}
                                title="Clique para realizar a importação do CSV"
                            />
                            <Button
                                className="p-button-primary p-mr-1"
                                icon="pi pi-file"
                                onClick={() => {
                                    setSelected(rowData.id);
                                    setType('.xml');
                                    showDialogUpload('.xml');
                                }}
                                title="Clique para realizar a importação do XML"
                            />
                            <Button
                                className="p-button-danger"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData, index.rowIndex)}
                                title="Clique para excluir a Importação"
                            />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}